import { ChangeDetectionStrategy, Component, computed, input, output } from '@angular/core';
import { RouterLink } from '@angular/router';
import { ButtonMenuComponent } from '@shared/components/button-menu/button-menu.component';
import { MenuItem } from 'primeng/api';
import { GroupListRow } from '@app/features/dashboard/group-list/group-list.utils';

/**
 * Uma linha da lista de grupos (`<tr app-group-list-row>`): nome (abre a edição) com o selo "Padrão" e os módulos
 * que o grupo libera, tipo de usuário, permissões com a barra leitura x gravação, usuários e o menu ⋯ com Editar e
 * Excluir (decisão do Victor: o Editar não fica solto na linha).
 */
@Component({
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: 'tr[app-group-list-row]',
  standalone: true,
  imports: [RouterLink, ButtonMenuComponent],
  templateUrl: './group-list-row.component.html',
  styleUrls: ['./group-list-row.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class GroupListRowComponent {
  readonly row = input.required<GroupListRow>();
  readonly canUpdate = input(false);
  readonly canDelete = input(false);
  readonly remove = output<GroupListRow>();

  readonly editLink = computed(() => ['/dashboard/groups/register', this.row().group.id]);

  readonly menuItems = computed<MenuItem[]>(() => {
    const items: MenuItem[] = [];
    if (this.canUpdate()) {
      items.push({ label: 'Editar', icon: 'pi pi-pencil', routerLink: this.editLink() });
    }
    // Grupo padrão não se exclui: o backend recusa (o startup o recria e o FULL é o acesso de todo o papel).
    if (this.canDelete() && !this.row().isDefault) {
      items.push({
        label: 'Excluir',
        icon: 'pi pi-trash',
        command: () => this.remove.emit(this.row()),
      });
    }
    return items;
  });

  readonly usersText = computed(() => {
    const count = this.row().usersCount;
    if (count === null) return '';
    return count === 1 ? '1 usuário' : `${count} usuários`;
  });
}
